import {
  CONVERSATION_STATUSES,
  type ConversationStatus,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import {
  ConversationFilterNames,
  conversationFilterData,
} from "@redotech/effect-api-shared/schema/conversation-filters";
import StatusIcon from "@redotech/redo-icons/status.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { ConversationStatusReadable } from "../ui/conversation-status-ui";

const EXCLUDED_STATUSES = new Set<ConversationStatus>([
  "HIDDEN",
  "ARCHIVED",
  "DELETED",
]);

const FILTERABLE_STATUSES = CONVERSATION_STATUSES.filter(
  (
    status,
  ): status is Exclude<ConversationStatus, "HIDDEN" | "ARCHIVED" | "DELETED"> =>
    !EXCLUDED_STATUSES.has(status),
);

export const StatusAdvancedFilter: ArrayStringTableFilter<ConversationStatus> =
  {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: StatusIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: conversationFilterData[ConversationFilterNames.STATUS],
    itemLabel: "status",
    itemLabelPlural: "statuses",
    values: FILTERABLE_STATUSES,
    display: (item: ConversationStatus) =>
      ConversationStatusReadable[item] ?? item,
    displayName: "Status",
  };
